import React, { JSX, cloneElement, isValidElement } from 'react';
import MuiChip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';
import { SpacingProps } from '@mui/system';
import EDBox from '../EDBox/EDBox';
import EDTooltip from '../Tooltip/EDTooltip';
interface IProps extends SpacingProps {
  avatar?: JSX.Element;
  color?: CommonPropsAndTypes.ColorTypeAlternate;
  deleteIcon?: JSX.Element;
  disabled?: boolean;
  disabledReason?: string;
  icon?: JSX.Element;
  label: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  onDelete?: (event: any) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  variant?: 'filled' | 'outlined';
  lockedChip?: boolean;
  opacity?: 0 | 1;
  grabbable?: boolean;
  dragHandle?: boolean;
  clickDisabled?: boolean;
  analysUtdelningSettingButton?: boolean;
  chipRadioButton?: boolean;
  chipRadioButtonSelectedChip?: boolean;
  fullWidth?: boolean;
}

/**
  Standardchip, kan inte dras
*/
export const EDChip: React.FC<
  React.PropsWithChildren<IProps & { className?: string }>
> = props => {
  const {
    children,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    marginX,
    marginY,
    disabledReason,
    deleteIcon,
    ...rest
  } = props;

  const typedDeleteIcon = isValidElement(deleteIcon)
    ? (deleteIcon as React.ReactElement)
    : undefined;
  const deleteIconWithTestId = typedDeleteIcon ? (
    cloneElement(typedDeleteIcon, {
      'data-testid':
        ((typedDeleteIcon.props as Record<string, unknown>)['data-testid'] as
          | string
          | undefined) ?? 'CancelIcon',
    } as Record<string, unknown>)
  ) : rest.onDelete ? (
    <CancelIcon data-testid="CancelIcon" />
  ) : undefined;

  return (
    <EDBox
      sx={[!!props.fullWidth && { width: '100%' }]}
      //lägg alla margin på yttre boxen
      margin={margin}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      marginX={marginX}
      marginY={marginY}
    >
      <EDTooltip
        title={rest.disabled ? disabledReason : undefined}
        enableClickOnTouch={rest.disabled}
      >
        <span>
          <MuiChip
            className={props.className}
            deleteIcon={deleteIconWithTestId}
            sx={[
              {
                flexDirection: props.lockedChip ? 'row-reverse' : {},
                justifyContent: 'space-between',
                '& .MuiChip-avatar': {
                  width: theme => theme.spacing(4),
                  height: theme => theme.spacing(4),
                  marginLeft: 0,
                },
                opacity: props.opacity,
                cursor: props.grabbable
                  ? 'grab'
                  : (props.dragHandle && !props.clickDisabled) ||
                    props.analysUtdelningSettingButton
                  ? 'pointer'
                  : {},
                color: props.chipRadioButtonSelectedChip ? 'common.white' : {},
                backgroundColor: props.chipRadioButtonSelectedChip
                  ? 'primary.main'
                  : {},
                '&:focus, &:hover': {
                  backgroundColor: props.chipRadioButtonSelectedChip
                    ? 'primary.main'
                    : {},
                },
                '& .MuiChip-icon': {
                  marginLeft: 1,
                  marginRight: 1,
                },
                '& .MuiChip-deleteIcon': {
                  color: props.chipRadioButtonSelectedChip
                    ? 'common.white'
                    : undefined,
                },
              },
              Boolean(props.fullWidth) && { width: '100%' },
              Boolean(props.chipRadioButton) && { justifyContent: 'center' },
              Boolean(props.avatar && props.onDelete) && {
                '& .MuiChip-label': { width: '100%' },
              },
              Boolean(props.analysUtdelningSettingButton) && {
                '& .MuiChip-label': {
                  paddingLeft: 0,
                },
              },
              Boolean(props.deleteIcon) && {
                '& .MuiChip-deleteIcon': { color: 'common.white' },
              },
            ]}
            component="div"
            {...rest}
          />
        </span>
      </EDTooltip>
    </EDBox>
  );
};

export default EDChip;
